var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"7e1b59ac156f9b48a59dd54fd84ab9f7eb030978"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["everest@noissue"]={id:"7e1b59ac156f9b48a59dd54fd84ab9f7eb030978"};
      